<div *ngIf="!loading">
  <div [class.fade-left]="fadeLeft$ | async" [class.fade-left-reverse]="fadeLeftReverse$ | async" [class.fade-right]="fadeRight$ | async"
       [class.fade-right-reverse]="fadeRightReverse$ | async">

    <app-notification class="sticky-notification" title="Enregistrement impossible" color="#e37055" *ngIf="submitted && errorMessages.length">
      <ul>
        <li *ngFor="let error of errorMessages">{{error}}</li>
      </ul>
    </app-notification>

    <div class="header">
      <h1 class="title">{{title()}}</h1>
    </div>

    <section>
      <h2 class="margin-top margin-bottom">Informations générales</h2>
      <form [formGroup]="thematicForm">
        <app-input title="Label (il doit être en anglais espacé par des tirets car sera l'url de la thématique, exemple: self-confidence)" formControlName="slug"></app-input>
        <app-radio-buttons formControlName="pillar" title="Pilier" [options]="pillarNames"></app-radio-buttons>
        <app-input title="Nom court" formControlName="name"></app-input>
        <app-input title="Intitulé complet du parcours" formControlName="title"></app-input>
        <p>Résumé</p>
        <textarea formControlName="resume" placeholder="Résumé de la thématique"></textarea>

        <h2 class="margin-bottom margin-top">Dynamiques proposées</h2>
        <h3 class="margin-top">Coaching en groupe</h3>
        <app-radio-buttons formControlName="coaching"></app-radio-buttons>
        <div *ngIf="gotCoaching">
          <app-checkmarks title="Sherpas associés" [checkboxes]="coachingSherpas" item-name="Sherpa associé"
          (changeSelection)="updateCoachingSherpasAssociated($event)"></app-checkmarks>
        </div>
        <h3 class="margin-top">Parole en groupe</h3>
        <app-radio-buttons formControlName="speech"></app-radio-buttons>
        <div *ngIf="gotSpeech">
          <app-checkmarks title="Sherpas associés" [checkboxes]="speechSherpas" item-name="Sherpa associé"
                          (changeSelection)="updateSpeechSherpasAssociated($event)"></app-checkmarks>
        </div>

      </form>

      <h2 class="margin-bottom margin-top">Sur quoi les talkers vont travailler et avancer ?</h2>
      <app-editable-list  [items]="workingOnForms" (add)="addWorkingOnForm()" (remove)="removeWorkingOnForm($event)">
        <ng-template #listItem let-item>
          <app-input class="full-width" [formControl]="item"></app-input>
        </ng-template>
      </app-editable-list>

      <h2 class="margin-bottom margin-top">Témoignages</h2>
      <app-editable-list  [items]="testimonialForms" (add)="addTestimonialForm()" (remove)="removeTestimonialForm($event)">
        <ng-template #listItem let-item>
          <form class="column gap full-width" [formGroup]="item">
            <div class="column gap">
              <p>Contenu</p>
              <textarea formControlName="description"></textarea>
            </div>
            <app-input title="Auteur" formControlName="author"></app-input>
            <br/>
          </form>

        </ng-template>
      </app-editable-list>

      <h2 class="margin-bottom margin-top">Chiffres clés</h2>
      <app-editable-list  [items]="keyNumberForms" (add)="addKeyNumberForm()" (remove)="removeKeyNumberForm($event)">
        <ng-template #listItem let-item>
          <form class="column gap full-width margin-top" [formGroup]="item">
            <app-input title="Chiffre" formControlName="stringNumber"></app-input>
            <div class="column no-gap margin-bottom">
              <p>Description</p>
              <textarea class="full-width" formControlName="description"></textarea>
            </div>
            <br/>
          </form>

        </ng-template>
      </app-editable-list>

      <h2 class="margin-top margin-bottom">Ressources épinglées</h2>
      <div class="pinned-section-header">
        <p class="text-muted">Ces ressources apparaîtront en premier lorsqu'un Talker filtre par cette thématique.</p>
        <span class="pinned-counter" [class.pinned-counter-full]="pinnedResources.length >= 3">
          {{ pinnedResources.length }}/3
        </span>
      </div>

      <!-- List of pinned resources -->
      <div class="pinned-resources-list" *ngIf="pinnedResources.length > 0">
        <div class="pinned-resource-item" *ngFor="let resource of pinnedResources; let i = index">
          <div class="pinned-resource-position">{{ i + 1 }}</div>
          <span class="pinned-resource-title">{{ resource.title }}</span>
          <app-icon class="pointer pinned-resource-remove" type="trash" (click)="removePinnedResource(i)"></app-icon>
        </div>
      </div>

      <!-- Empty state -->
      <div class="pinned-empty-state" *ngIf="pinnedResources.length === 0 && !showResourceSearch">
        <p>Aucune ressource épinglée</p>
      </div>

      <!-- Search field for adding resources - Inline autocomplete -->
      <div class="pinned-search-wrapper" *ngIf="canAddMoreResources()">
        <div class="pinned-search-container" [class.pinned-search-active]="showResourceSearch">
          <div class="pinned-search-input-row">
            <app-icon type="search" class="pinned-search-icon"></app-icon>
            <input
              type="text"
              [formControl]="resourceSearchControl"
              placeholder="Rechercher une ressource à épingler..."
              class="pinned-search-input"
              (focus)="showAddResource()"
            />
            <app-icon
              *ngIf="resourceSearchControl.value"
              type="close"
              class="pointer pinned-clear-icon"
              (click)="clearResourceSearch()">
            </app-icon>
          </div>

          <!-- Autocomplete dropdown -->
          <div class="pinned-autocomplete-dropdown" *ngIf="showResourceSearch && (isSearchingResources || resourceSearchResults.length > 0 || (resourceSearchControl.value && resourceSearchControl.value.length >= 2))">
            <!-- Loading indicator -->
            <div class="pinned-autocomplete-loading" *ngIf="isSearchingResources">
              <app-spinner></app-spinner>
              <span>Recherche...</span>
            </div>

            <!-- Search results -->
            <div
              class="pinned-autocomplete-item"
              *ngFor="let result of resourceSearchResults"
              (click)="addPinnedResource(result)"
            >
              <app-icon type="add" class="pinned-autocomplete-add-icon"></app-icon>
              <span>{{ result.title }}</span>
            </div>

            <!-- No results message -->
            <div class="pinned-autocomplete-empty" *ngIf="resourceSearchControl.value && resourceSearchControl.value.length >= 2 && resourceSearchResults.length === 0 && !isSearchingResources">
              <app-icon type="search"></app-icon>
              <span>Aucune ressource trouvée pour "{{ resourceSearchControl.value }}"</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Max reached message -->
      <div class="pinned-max-reached" *ngIf="!canAddMoreResources()">
        <app-icon type="check-dot"></app-icon>
        <span>Maximum de 3 ressources atteint</span>
      </div>

      <h2 class="margin-top margin-bottom">Image</h2>
      <div class="margin-top margin-bottom">
        <h5 class="text-bold">Vignette</h5>
        <app-upload-file  (updateFile)="updateFile($event)" [update]="!!thematic" image></app-upload-file>
      </div>
      <div class="margin-top margin-bottom">
        <h5 class="text-bold">Bannière</h5>
        <app-upload-file  (updateFile)="updateBannerFile($event)" [update]="!!thematic" image></app-upload-file>
      </div>

      <div class=" margin-top-xl">
        <a *ngIf="thematic && !thematic.isArchived" (click)="archiveThematic()">Archiver cette thématique</a>
      </div>
    </section>
  </div>
</div>
